export const User = {
    user: null,
    users: []
}